/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_LinkInputs */

const en_import_link = /** @type {(inputs: Import_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recipe link`)
};

const de_import_link = /** @type {(inputs: Import_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezept-Link`)
};

/**
* | output |
* | --- |
* | "Recipe link" |
*
* @param {Import_LinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_link = /** @type {((inputs?: Import_LinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_LinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_link(inputs)
	return en_import_link(inputs)
});